module.exports = __webpack_public_path__ + "img/twohop.7a4a11f9.jpeg";